import React from 'react';

import { Card, CardContent, cn } from '@eluve/components';

export const WhiteCard: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <Card className="border-border-tertiary bg-bg-primary">
    <CardContent className={cn('p-6', className)}>{children}</CardContent>
  </Card>
);
